/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Occupationschedule1Inputs */



/**
* | output |
* | --- |
* | "Occupation schedule" |
*
* @param {Br_History_Key_Occupationschedule1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_occupationschedule1 = /** @type {((inputs?: Br_History_Key_Occupationschedule1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Occupationschedule1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Occupation schedule")
	return /** @type {LocalizedString} */ ("Planning d'occupation")
});
export { br_history_key_occupationschedule1 as "br_history_key_occupationSchedule" }